// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__30Kmd","messages":"Chat_messages__T2Nq4","dateDivider":"Chat_dateDivider__1dMyx"};